import api, { unwrap } from './client';

// Customer-facing booking flow (Phase 5).

// Approved-clinic discovery — optional ?city, ?state, ?lat, ?lng for proximity.
export async function listPublicClinics(params = {}) {
  return unwrap(await api.get('/clinics', { params }));
}

export async function getPublicClinic(id) {
  return unwrap(await api.get(`/clinics/${id}`));
}

export async function getOrderById(id) {
  // Staff/admin path uses the dedicated admin route. For patients there is no
  // public detail endpoint, so we fall back to scanning their own list.
  try {
    return unwrap(await api.get(`/admin/orders/${id}`));
  } catch (_) {
    const list = unwrap(await api.get('/orders/my')) || [];
    return list.find?.((o) => o._id === id) || null;
  }
}

export async function assignClinic(orderId, clinicId) {
  return unwrap(await api.post(`/orders/${orderId}/assign-clinic`, { clinicId }));
}

export async function scheduleBooking(orderId, scheduledAt, scheduledSlot) {
  return unwrap(await api.post(`/orders/${orderId}/schedule`, { scheduledAt, scheduledSlot }));
}

// Patient-facing slot picker: what slots are open on `date` (YYYY-MM-DD)
// at the given clinic. Response: { date, closed, reason?, slots: [{startAt,label,durationMin,available}] }.
export async function getAvailableSlots(clinicId, ymd) {
  return unwrap(await api.get(`/clinics/${clinicId}/available-slots`, { params: { date: ymd } }));
}

// Clinic-side check-in (vendor role).
export async function checkInBooking(code) {
  return unwrap(await api.post('/vendor/check-in', { code }));
}

// Vendor captures the in-person balance.
export async function captureBalance(orderId, payload = {}) {
  return unwrap(await api.post(`/vendor/orders/${orderId}/capture-balance`, payload));
}
